const theme = {
    token: {
        colorPrimary: '#864ef5',
        colorInfo: '#864ef5',
        colorLink: '#864ef5',
        borderRadius: 8,
        fontFamily: '"Be Vietnam Pro", "Segoe UI", sans-serif',
        fontSize: 14,
        colorBgLayout: '#f6f5f8',
        colorBgContainer: '#ffffff',
        colorBorder: '#e7e2f0',
        colorBorderSecondary: '#eeeaf5',
        controlHeight: 36,
        boxShadowTertiary: '0 1px 2px rgba(28, 22, 48, 0.04)',
    },
    components: {
        Button: {
            primaryShadow: 'none',
            defaultShadow: 'none',
            fontWeight: 500,
        },
        Table: {
            headerBg: '#f7f5fb',
            headerColor: '#5c5470',
            headerSplitColor: 'transparent',
            rowHoverBg: '#f6f3ff',
            borderColor: '#eeeaf5',
            cellFontSize: 13,
            cellPaddingBlock: 12,
            cellPaddingInline: 12,
            headerBorderRadius: 0,
        },
        Card: {
            headerBg: 'transparent',
            headerFontSize: 15,
            borderRadiusLG: 12,
            paddingLG: 20,
        },
        Layout: {
            bodyBg: '#f6f5f8',
            headerBg: '#ffffff',
            headerHeight: 64,
            siderBg: '#121018',
        },
        Menu: {
            darkItemBg: 'transparent',
            darkSubMenuItemBg: 'transparent',
            darkItemColor: '#b7b0c9',
            darkItemHoverColor: '#f4f1fb',
            darkItemHoverBg: 'rgba(255, 255, 255, 0.05)',
            darkItemSelectedColor: '#ffffff',
            darkItemSelectedBg: 'rgba(134, 78, 245, 0.2)',
            darkGroupTitleColor: '#8d879c',
            itemBorderRadius: 8,
            itemHeight: 40,
            itemMarginInline: 8,
            itemMarginBlock: 2,
            iconSize: 16,
            groupTitleFontSize: 12,
        },
        Input: {
            activeShadow: '0 0 0 2px rgba(134, 78, 245, 0.12)',
        },
        Tag: {
            defaultBg: '#f6f3ff',
            defaultColor: '#5c5470',
        },
        Modal: {
            borderRadiusLG: 12,
        },
        Form: {
            itemMarginBottom: 16,
        },
    },
};

export default theme;
